import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  emailValidator,
  MobileNoIntValidator,
  requiredValidator,
} from "./../../components/formFields/CommonValidator";
import { useAppDispatch, useAppSelector } from "./../../app/hooks";
import {
  createFlightQuotation,
  getFlightQuotationByID,
  updateFlightQuotation,
} from "./services/quotation.services";
import {
  clearFlightQuotationInformation,
  setQuotationType,
} from "./quotationSlice";
import ShadowCard from "./../../components/common/ShadowCard";
import moment from "moment";
import { getFlightInquiryByID } from "./../inquiry/services/inquiry.services";
import {
  getContactByID,
  insertContactFromOtherPlace,
} from "./../contact/services/contact.services";
import FormSelectionField from "./../../components/formFields/FormSelectionField";
import {
  AIRLINESTOPS,
  BOOKINGSTATUSHOTEL,
  FLIGHTQUOTETYPE,
  NAMEPREFIX,
  TRIPTYPE,
} from "./../../_contstants/common";
import { clearInquiryDetails } from "./../inquiry/inquirySlice";
import { LoadingPanel } from "./../../components/layout/Loading";
import { getLeadByID } from "./../lead/services/lead.services";
import { getAllActiveCurrencies } from "./../currency/services/currency.services";
import FormRadioGroup from "../../components/formFields/FormRadioGroup";
import { getAllVendorsBySearch } from "../vendor/services/vendor.services";
import { ICurrency } from "../currency/currencyModel";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import { IAirline } from "../airline/airlineModel";
import { getAllActiveAirlines } from "../airline/services/airline.services";
import FormTextField from "../../components/formFields/FormTextField";
// import { IFlightPlace } from "../flightplace/flightplaceModel";
import {
  // getAllActiveFlightPlaces,
  getAllFlightPlaceBySearch,
} from "../flightplace/services/flightplace.services";
import FormTimePicker from "../../components/formFields/FormTimeField";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import RippleButton from "../../components/common/RippleButton";
import { ILeadSource } from "../leadsource/leadsourceModel";
import { getAllActiveLeadSource } from "../leadsource/services/leadsource.service";
import { getAllActiveCompanies } from "../company/services/company.services";
import { ICompany } from "../company/companyModel";
import { getAllActiveAirlineClass } from "../airlineclass/services/airlineclass.services";
import { IAirlineClass } from "../airlineclass/airlineclassModel";
import { getAdminSettings } from "../adminsetting/services/adminsetting.services";
import { clearAdminSettingDetails } from "../adminsetting/adminsettingSlice";
import { clearLeadDetails } from "../lead/leadSlice";
import { clearContactDetails } from "../contact/contactSlice";
import FormIncrementalSearch from "../../components/formFields/FormIncrementalSearch";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const TotalChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const DepartureAdult = formRenderProps.valueGetter("DepartureAdult") || 0;
  const AdultsCost = formRenderProps.valueGetter("AdultsCost") || 0;
  const AdultsMarkup = formRenderProps.valueGetter("AdultsMarkup") || 0;
  const DepartureChild = formRenderProps.valueGetter("DepartureChild") || 0;
  const ChildCost = formRenderProps.valueGetter("ChildCost") || 0;
  const ChildMarkup = formRenderProps.valueGetter("ChildMarkup") || 0;
  const DepartureInfant = formRenderProps.valueGetter("DepartureInfant") || 0;
  const InfantCost = formRenderProps.valueGetter("InfantCost") || 0;
  const InfantMarkup = formRenderProps.valueGetter("InfantMarkup") || 0;
  // const TotalMarkup = formRenderProps.valueGetter("TotalMarkup") || 0;
  // const ReturnAdult = formRenderProps.valueGetter("ReturnAdult") || 0;
  const ReturnAdultsCost = formRenderProps.valueGetter("ReturnAdultsCost") || 0;
  const ReturnAdultsMarkup =
    formRenderProps.valueGetter("ReturnAdultsMarkup") || 0;
  // const ReturnChild = formRenderProps.valueGetter("ReturnChild") || 0;
  const ReturnChildCost = formRenderProps.valueGetter("ReturnChildCost") || 0;
  const ReturnChildMarkup =
    formRenderProps.valueGetter("ReturnChildMarkup") || 0;
  // const ReturnInfant = formRenderProps.valueGetter("ReturnInfant") || 0;
  const ReturnInfantCost = formRenderProps.valueGetter("ReturnInfantCost") || 0;
  const ReturnInfantMarkup =
    formRenderProps.valueGetter("ReturnInfantMarkup") || 0;
  const GSTPer = formRenderProps.valueGetter("GSTPer") || 0;
  const GSTAmount = formRenderProps.valueGetter("GSTAmount") || 0;
  const TCSAmount = formRenderProps.valueGetter("TCSAmount") || 0;
  // const MainTotalMarkup = formRenderProps.valueGetter("MainTotalMarkup") || 0;
  const TripType = formRenderProps.valueGetter("TripType");

  useEffect(() => {
    const AdultTotalMarkup = DepartureAdult * AdultsMarkup;
    const ChildTotalMarkup = DepartureChild * ChildMarkup;
    const InfantTotalMarkup = DepartureInfant * InfantMarkup;

    const ReturnAdultTotalMarkup = DepartureAdult * ReturnAdultsMarkup;
    const ReturnChildTotalMarkup = DepartureChild * ReturnChildMarkup;
    const ReturnInfantTotalMarkup = DepartureInfant * ReturnInfantMarkup;
    // const ReturnAdultTotalMarkup = ReturnAdult * ReturnAdultsMarkup;
    // const ReturnChildTotalMarkup = ReturnChild * ReturnChildMarkup;
    // const ReturnInfantTotalMarkup = ReturnInfant * ReturnInfantMarkup;

    formRenderProps.onChange("TotalDeparturePax", {
      value: +DepartureAdult + +DepartureChild + +DepartureInfant,
    });
    // formRenderProps.onChange("TotalReturnPax", {
    //   value: +ReturnAdult + +ReturnChild + +ReturnInfant,
    // });
    formRenderProps.onChange("TotalCost", {
      value: +AdultsCost + +ChildCost + +InfantCost,
    });
    formRenderProps.onChange("TotalMarkup", {
      value: +AdultsMarkup + +ChildMarkup + +InfantMarkup,
    });
    formRenderProps.onChange("GrandTotal", {
      value:
        +(AdultsCost * DepartureAdult) +
        +(ChildCost * DepartureChild) +
        +(InfantCost * DepartureInfant) +
        +(AdultsMarkup * DepartureAdult) +
        +(ChildMarkup * DepartureChild) +
        +(InfantMarkup * DepartureInfant),
    });

    formRenderProps.onChange("TotalReturnCost", {
      value: +ReturnAdultsCost + +ReturnChildCost + +ReturnInfantCost,
    });
    formRenderProps.onChange("TotalReturnMarkup", {
      value: +ReturnAdultsMarkup + +ReturnChildMarkup + +ReturnInfantMarkup,
    });
    formRenderProps.onChange("ReturnGrandTotal", {
      value:
        +(ReturnAdultsCost * DepartureAdult) +
        +(ReturnChildCost * DepartureChild) +
        +(ReturnInfantCost * DepartureInfant) +
        +(ReturnAdultsMarkup * DepartureAdult) +
        +(ReturnChildMarkup * DepartureChild) +
        +(ReturnInfantMarkup * DepartureInfant),
    });
    // formRenderProps.onChange("ReturnGrandTotal", {
    //   value:
    //     +(ReturnAdultsCost * ReturnAdult) +
    //     +(ReturnChildCost * ReturnChild) +
    //     +(ReturnInfantCost * ReturnInfant) +
    //     +(ReturnAdultsMarkup * ReturnAdult) +
    //     +(ReturnChildMarkup * ReturnChild) +
    //     +(ReturnInfantMarkup * ReturnInfant),
    // });

    formRenderProps.onChange("MainAdultsCost", {
      value: +AdultsCost + +ReturnAdultsCost,
    });
    formRenderProps.onChange("MainAdultsMarkup", {
      value: +AdultsMarkup + +ReturnAdultsMarkup,
    });
    formRenderProps.onChange("MainChildCost", {
      value: +ChildCost + +ReturnChildCost,
    });
    formRenderProps.onChange("MainChildMarkup", {
      value: +ChildMarkup + +ReturnChildMarkup,
    });
    formRenderProps.onChange("MainInfantCost", {
      value: +InfantCost + +ReturnInfantCost,
    });
    formRenderProps.onChange("MainInfantMarkup", {
      value: +InfantMarkup + +ReturnInfantMarkup,
    });

    formRenderProps.onChange("MainTotalCost", {
      value:
        +AdultsCost +
        +ChildCost +
        +InfantCost +
        +ReturnAdultsCost +
        +ReturnChildCost +
        +ReturnInfantCost,
    });
    formRenderProps.onChange("MainTotalMarkup", {
      value:
        +AdultsMarkup +
        +ChildMarkup +
        +InfantMarkup +
        +ReturnAdultsMarkup +
        +ReturnChildMarkup +
        +ReturnInfantMarkup,
    });
    formRenderProps.onChange("MainGrandTotal", {
      value:
        +(AdultsCost * DepartureAdult) +
        +(ChildCost * DepartureChild) +
        +(InfantCost * DepartureInfant) +
        +(ReturnAdultsCost * DepartureAdult) +
        +(ReturnChildCost * DepartureChild) +
        +(ReturnInfantCost * DepartureInfant) +
        +(AdultsMarkup * DepartureAdult) +
        +(ChildMarkup * DepartureChild) +
        +(InfantMarkup * DepartureInfant) +
        +(ReturnAdultsMarkup * DepartureAdult) +
        +(ReturnChildMarkup * DepartureChild) +
        +(ReturnInfantMarkup * DepartureInfant),
    });
    // formRenderProps.onChange("MainGrandTotal", {
    //   value:
    //     +(AdultsCost * DepartureAdult) +
    //     +(ChildCost * DepartureChild) +
    //     +(InfantCost * DepartureInfant) +
    //     +(ReturnAdultsCost * ReturnAdult) +
    //     +(ReturnChildCost * ReturnChild) +
    //     +(ReturnInfantCost * ReturnInfant) +
    //     +(AdultsMarkup * DepartureAdult) +
    //     +(ChildMarkup * DepartureChild) +
    //     +(InfantMarkup * DepartureInfant) +
    //     +(ReturnAdultsMarkup * ReturnAdult) +
    //     +(ReturnChildMarkup * ReturnChild) +
    //     +(ReturnInfantMarkup * ReturnInfant),
    // });
    if (TripType === "One Way") {
      formRenderProps.onChange("SubTotalAfterGST", {
        value: +(
          +(AdultsCost * DepartureAdult) +
          +(ChildCost * DepartureChild) +
          +(InfantCost * DepartureInfant) +
          +(AdultsMarkup * DepartureAdult) +
          +(ChildMarkup * DepartureChild) +
          +(InfantMarkup * DepartureInfant) +
          +GSTAmount
        )?.toFixed(2),
      });
      formRenderProps.onChange("SubTotalAfterTCS", {
        value: +(
          +(AdultsCost * DepartureAdult) +
          +(ChildCost * DepartureChild) +
          +(InfantCost * DepartureInfant) +
          +(AdultsMarkup * DepartureAdult) +
          +(ChildMarkup * DepartureChild) +
          +(InfantMarkup * DepartureInfant) +
          +GSTAmount +
          +TCSAmount
        )?.toFixed(2),
      });
    } else {
      formRenderProps.onChange("SubTotalAfterGST", {
        value: +(
          +(AdultsCost * DepartureAdult) +
          +(ChildCost * DepartureChild) +
          +(InfantCost * DepartureInfant) +
          +(ReturnAdultsCost * DepartureAdult) +
          +(ReturnChildCost * DepartureChild) +
          +(ReturnInfantCost * DepartureInfant) +
          +(AdultsMarkup * DepartureAdult) +
          +(ChildMarkup * DepartureChild) +
          +(InfantMarkup * DepartureInfant) +
          +(ReturnAdultsMarkup * DepartureAdult) +
          +(ReturnChildMarkup * DepartureChild) +
          +(ReturnInfantMarkup * DepartureInfant) +
          +GSTAmount
        )?.toFixed(2),
      });
      formRenderProps.onChange("SubTotalAfterTCS", {
        value: +(
          +(AdultsCost * DepartureAdult) +
          +(ChildCost * DepartureChild) +
          +(InfantCost * DepartureInfant) +
          +(ReturnAdultsCost * DepartureAdult) +
          +(ReturnChildCost * DepartureChild) +
          +(ReturnInfantCost * DepartureInfant) +
          +(AdultsMarkup * DepartureAdult) +
          +(ChildMarkup * DepartureChild) +
          +(InfantMarkup * DepartureInfant) +
          +(ReturnAdultsMarkup * DepartureAdult) +
          +(ReturnChildMarkup * DepartureChild) +
          +(ReturnInfantMarkup * DepartureInfant) +
          +GSTAmount +
          +TCSAmount
        )?.toFixed(2),
      });
      // formRenderProps.onChange("SubTotalAfterGST", {
      //   value: +(
      //     +(AdultsCost * DepartureAdult) +
      //     +(ChildCost * DepartureChild) +
      //     +(InfantCost * DepartureInfant) +
      //     +(ReturnAdultsCost * ReturnAdult) +
      //     +(ReturnChildCost * ReturnChild) +
      //     +(ReturnInfantCost * ReturnInfant) +
      //     +(AdultsMarkup * DepartureAdult) +
      //     +(ChildMarkup * DepartureChild) +
      //     +(InfantMarkup * DepartureInfant) +
      //     +(ReturnAdultsMarkup * ReturnAdult) +
      //     +(ReturnChildMarkup * ReturnChild) +
      //     +(ReturnInfantMarkup * ReturnInfant) +
      //     +GSTAmount
      //   )?.toFixed(2),
      // });
      // formRenderProps.onChange("SubTotalAfterTCS", {
      //   value: +(
      //     +(AdultsCost * DepartureAdult) +
      //     +(ChildCost * DepartureChild) +
      //     +(InfantCost * DepartureInfant) +
      //     +(ReturnAdultsCost * ReturnAdult) +
      //     +(ReturnChildCost * ReturnChild) +
      //     +(ReturnInfantCost * ReturnInfant) +
      //     +(AdultsMarkup * DepartureAdult) +
      //     +(ChildMarkup * DepartureChild) +
      //     +(InfantMarkup * DepartureInfant) +
      //     +(ReturnAdultsMarkup * ReturnAdult) +
      //     +(ReturnChildMarkup * ReturnChild) +
      //     +(ReturnInfantMarkup * ReturnInfant) +
      //     +GSTAmount +
      //     +TCSAmount
      //   )?.toFixed(2),
      // });
    }

    if (TripType === "One Way") {
      formRenderProps.onChange("GSTAmount", {
        value: (
          ((+AdultTotalMarkup + +ChildTotalMarkup + +InfantTotalMarkup) *
            GSTPer) /
          100
        )?.toFixed(2),
      });
    } else {
      formRenderProps.onChange("GSTAmount", {
        value: (
          ((+AdultTotalMarkup +
            +ChildTotalMarkup +
            +InfantTotalMarkup +
            +ReturnAdultTotalMarkup +
            +ReturnChildTotalMarkup +
            +ReturnInfantTotalMarkup) *
            GSTPer) /
          100
        )?.toFixed(2),
      });
    }
  }, [
    DepartureAdult,
    AdultsCost,
    AdultsMarkup,
    DepartureChild,
    ChildCost,
    ChildMarkup,
    DepartureInfant,
    InfantCost,
    InfantMarkup,
    // ReturnAdult,
    ReturnAdultsCost,
    ReturnAdultsMarkup,
    // ReturnChild,
    ReturnChildCost,
    ReturnChildMarkup,
    // ReturnInfant,
    ReturnInfantCost,
    ReturnInfantMarkup,
    GSTAmount,
    TCSAmount,
    GSTPer,
    TripType,
  ]);

  return null;
};

const GSTChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const location = useLocation();
  const FlightQuotationID = location.state?.FlightQuotationID;

  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails
  );
  const TCSPer = formRenderProps.valueGetter("TCSPer") || 0;
  const SubTotalAfterGST = formRenderProps.valueGetter("SubTotalAfterGST") || 0;
  const IsTCSApplicable = formRenderProps.valueGetter("IsTCSApplicable");

  useEffect(() => {
    if (!FlightQuotationID) {
      formRenderProps.onChange("GSTPer", {
        value: AdminSettingDetails?.GST || null,
      });
      formRenderProps.onChange("TCSPer", {
        value: AdminSettingDetails?.TCSUnderPer || null,
      });
    }
  }, [AdminSettingDetails, FlightQuotationID]);

  useEffect(() => {
    if (IsTCSApplicable && TCSPer) {
      if (SubTotalAfterGST <= 700000) {
        formRenderProps.onChange("TCSAmount", {
          value: +((+SubTotalAfterGST * TCSPer) / 100)?.toFixed(2),
        });
      } else {
        const firstTCSAmount = (700000 * TCSPer) / 100;
        const remainingTCSAmount = +SubTotalAfterGST - 700000;
        const secondTCSAmount = (+remainingTCSAmount * 20) / 100;

        formRenderProps.onChange("TCSAmount", {
          value: +(+firstTCSAmount + +secondTCSAmount)?.toFixed(2),
        });
      }
    } else {
      formRenderProps.onChange("TCSAmount", {
        value: 0,
      });
    }
  }, [IsTCSApplicable, TCSPer, SubTotalAfterGST]);

  return null;
};

const CreateFlightQuotation: React.FC = () => {
  const gridRef = useRef<any>(null);
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const FlightQuotationID = location.state?.FlightQuotationID;
  const InquiryID = location.state?.InquiryID;

  const loading = useAppSelector((state) => state.quotation.loading);
  const contactLoading = useAppSelector((state) => state.contact.formLoading);
  const FlightQuotationDetail = useAppSelector(
    (state) => state.quotation.FlightQuotationDetail
  );
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSourceList
  );
  const InquiryFlightDetails = useAppSelector(
    (state) => state.inquiry.InquiryFlightDetails
  );

  const LeadDetails = useAppSelector((state) => state.lead.LeadDetails);
  const leadLoading = useAppSelector((state) => state.lead.formLoading);
  const ContactDetails = useAppSelector(
    (state) => state.contact.ContactDetails
  );
  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails
  );

  // const VendorList = useAppSelector((state) => state.vendor.VendorList);

  const CurrencyList = useAppSelector((state) => state.currency.CurrencyList);

  const AirlineList = useAppSelector((state) => state.airline.AirlineList);
  const CompanyList = useAppSelector((state) => state.company.CompanyList);
  const AirlineClassList = useAppSelector(
    (state) => state.airlineclass.AirlineClassList
  );

  // const FlightPlaceList = useAppSelector(
  //   (state) => state.flightplace.FlightPlaceList
  // );

  const LeadID = location.state?.LeadID;
  const ContactID = location.state?.ContactID;

  const [formKey, setFormKey] = useState(1);
  const [initialValues, setInitialValues] = useState<any>(
    FlightQuotationDetail
  );

  useEffect(() => {
    dispatch(getAllActiveCurrencies());
    dispatch(getAllActiveAirlines());
    // dispatch(getAllActiveVendors());
    // dispatch(getAllActiveFlightPlaces());
    dispatch(getAllActiveLeadSource());
    dispatch(getAllActiveCompanies());
    dispatch(getAllActiveAirlineClass());
    if (!FlightQuotationID) {
      dispatch(getAdminSettings());
    }

    if (FlightQuotationID) {
      dispatch(getFlightQuotationByID({ ID: +FlightQuotationID }));
    } else if (InquiryID) {
      dispatch(getFlightInquiryByID(InquiryID));
    } else if (LeadID) {
      dispatch(getLeadByID(LeadID));
    } else if (ContactID) {
      dispatch(getContactByID(ContactID));
    }

    return () => {
      dispatch(clearFlightQuotationInformation());
      dispatch(clearInquiryDetails());
      dispatch(clearAdminSettingDetails());
    };
  }, []);

  useEffect(() => {
    if (InquiryFlightDetails?.ID) {
      setInitialValues({
        ...initialValues,
        FlightScope: 2,
        Initial: InquiryFlightDetails?.Initial,
        FirstName: InquiryFlightDetails?.FirstName,
        LastName: InquiryFlightDetails?.LastName,
        MobileNo: InquiryFlightDetails?.MobileNo,
        EmailID: InquiryFlightDetails?.EmailID,
        LeadSourceID: InquiryFlightDetails?.InquirySourceID,
        ContactID: InquiryFlightDetails?.ContactID,
        LeadID: InquiryFlightDetails?.LeadID,
        InquiryID: InquiryFlightDetails?.ID,
        TripType: InquiryFlightDetails?.TripType,
        DepartureDate: InquiryFlightDetails?.DepartureDate,
        ReturnDepartureDate: InquiryFlightDetails?.ReturnDate,
        FlightClassID: InquiryFlightDetails?.FlightClassID,
        FromAirportID: InquiryFlightDetails?.FromPlaceID,
        ToAirportID: InquiryFlightDetails?.ToPlaceID,
        ReturnFromAirportID:
          InquiryFlightDetails?.TripType === "Two Way"
            ? InquiryFlightDetails?.ToPlaceID
            : null,
        ReturnToAirportID:
          InquiryFlightDetails?.TripType === "Two Way"
            ? InquiryFlightDetails?.FromPlaceID
            : null,
        from_place_options: InquiryFlightDetails?.from_place_options || [],
        to_place_options: InquiryFlightDetails?.to_place_options || [],
        return_from_place_options:
          InquiryFlightDetails?.TripType === "Two Way"
            ? InquiryFlightDetails?.to_place_options || []
            : [],
        return_to_place_options:
          InquiryFlightDetails?.TripType === "Two Way"
            ? InquiryFlightDetails?.from_place_options || []
            : [],
        DepartureAdult: InquiryFlightDetails?.Adult,
        DepartureChild: InquiryFlightDetails?.Child
          ? InquiryFlightDetails?.Child === "zero"
            ? 0
            : +InquiryFlightDetails?.Child
          : 0,
        DepartureInfant: InquiryFlightDetails?.Infant
          ? InquiryFlightDetails?.Infant === "zero"
            ? 0
            : +InquiryFlightDetails?.Infant
          : 0,
        // ReturnAdult:
        //   InquiryFlightDetails?.TripType === "Two Way"
        //     ? InquiryFlightDetails?.Adult
        //     : null,
        // ReturnChild:
        //   InquiryFlightDetails?.TripType === "Two Way"
        //     ? InquiryFlightDetails?.Child
        //     : null,
        // ReturnInfant:
        //   InquiryFlightDetails?.TripType === "Two Way"
        //     ? InquiryFlightDetails?.Infant
        //     : null,
      });
    }
    return () => {
      dispatch(clearInquiryDetails());
    };
  }, [InquiryFlightDetails]);

  useEffect(() => {
    if (LeadDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: LeadDetails?.Initial,
        FirstName: LeadDetails?.FirstName,
        LastName: LeadDetails?.LastName,
        MobileNo: LeadDetails?.MobileNo,
        EmailID: LeadDetails?.EmailID,
        LeadSourceID: LeadDetails?.LeadSourceID,
        ContactID: LeadDetails?.ContactID,
        LeadID: LeadDetails?.ID,
      });
    }
    return () => {
      dispatch(clearLeadDetails());
    };
  }, [LeadDetails]);

  useEffect(() => {
    if (ContactDetails?.ID) {
      setInitialValues({
        ...initialValues,
        Initial: ContactDetails?.Initial,
        FirstName: ContactDetails?.FirstName,
        LastName: ContactDetails?.LastName,
        MobileNo: ContactDetails?.MobileNo,
        EmailID: ContactDetails?.EmailID,
        LeadSourceID: ContactDetails?.LeadSourceID,
        ContactID: ContactDetails?.ID,
      });
    }
    return () => {
      dispatch(clearContactDetails());
    };
  }, [ContactDetails]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      ...FlightQuotationDetail,
    });
  }, [FlightQuotationDetail]);

  useEffect(() => {
    if (!FlightQuotationID) {
      setInitialValues({
        ...initialValues,
        FareRules: AdminSettingDetails.FlightTermsAndCondition,
      });
    }
  }, [AdminSettingDetails]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [initialValues]);

  const handleHotelSearchChange = React.useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllFlightPlaceBySearch(search));
      if (result.payload) {
        formRenderProps.onChange(field, {
          value: result.payload,
        });
      }
    },
    [dispatch]
  );
  const handleVendorSearchChange = React.useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllVendorsBySearch(search));
      if (result.payload) {
        formRenderProps.onChange(field, {
          value: result.payload,
        });
      }
    },
    [dispatch]
  );

  const handleSubmit = async (values: any) => {
    let contactID = values?.ContactID ? +values?.ContactID : null;
    const insertContactPayload = {
      Initial: values?.Initial ? values?.Initial : "",
      FirstName: values?.FirstName ? values?.FirstName : "",
      LastName: values?.LastName ? values?.LastName : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      CountryCode: values?.CountryCode ? values?.CountryCode : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
    };

    if (!FlightQuotationID && !InquiryID && !LeadID && !ContactID) {
      const response = await dispatch(
        insertContactFromOtherPlace(insertContactPayload)
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.Data?.ID
      ) {
        contactID = +response.payload.Data.ID || null;
      } else {
        return;
      }
    }

    try {
      if (FlightQuotationID) {
        const editPayload = {
          ID: FlightQuotationID ? +FlightQuotationID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          CountryCode: values?.CountryCode ? values?.CountryCode : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          FlightScope: values?.FlightScope ? +values?.FlightScope : null,
          VendorID: values?.VendorID ? +values?.VendorID : null,
          CurrencyID: values?.CurrencyID ? +values?.CurrencyID : null,

          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          FlightClassID: values?.FlightClassID ? +values?.FlightClassID : null,
          GSTPer: values?.GSTPer ? +values?.GSTPer : null,
          GSTAmount: values?.GSTAmount ? +values?.GSTAmount : null,
          TCSPer: values?.TCSPer ? +values?.TCSPer : null,
          TCSAmount: values?.TCSAmount ? +values?.TCSAmount : null,
          ValidUntil: values?.ValidUntil
            ? moment(values?.ValidUntil)?.format("YYYY-MM-DD")
            : null,

          TripType: values?.TripType ? values?.TripType : "",
          TextBaseDescription: values?.TextBaseDescription || "",
          IsRefundable: values?.IsRefundable || false,
          IsFlightRateMayBeChanged: values?.IsFlightRateMayBeChanged || false,
          AirlineID: values?.AirlineID ? +values?.AirlineID : null,
          AirlineNo: values?.AirlineNo || "",
          FromAirportID: values?.FromAirportID ? +values?.FromAirportID : null,
          ToAirportID: values?.ToAirportID ? +values?.ToAirportID : null,
          DepartureDate: values?.DepartureDate
            ? moment(values?.DepartureDate)?.format("YYYY-MM-DD")
            : null,
          DepartureTime: values?.DepartureTime
            ? moment(values?.DepartureTime)?.format("HH:mm:ss")
            : "",
          ArrivalDate: values?.ArrivalDate
            ? moment(values?.ArrivalDate)?.format("YYYY-MM-DD")
            : null,
          ArrivalTime: values?.ArrivalTime
            ? moment(values?.ArrivalTime)?.format("HH:mm:ss")
            : "",
          Stops: values?.Stops || "",
          AdultsCost: values?.AdultsCost ? +values?.AdultsCost : null,
          AdultsMarkup: values?.AdultsMarkup ? +values?.AdultsMarkup : null,
          ChildCost: values?.ChildCost ? +values?.ChildCost : null,
          ChildMarkup: values?.ChildMarkup ? +values?.ChildMarkup : null,
          InfantCost: values?.InfantCost ? +values?.InfantCost : null,
          InfantMarkup: values?.InfantMarkup ? +values?.InfantMarkup : null,
          FareRules: values?.FareRules || "",
          IsSharePPPrice: values?.IsSharePPPrice || false,

          GrandTotal: values?.GrandTotal ? +values?.GrandTotal : null,
          TotalMarkup: values?.TotalMarkup ? +values?.TotalMarkup : null,
          TotalCost: values?.TotalCost ? +values?.TotalCost : null,
          ReturnCurrencyID: values?.ReturnCurrencyID
            ? +values?.ReturnCurrencyID
            : null,
          ReturnAirlineID: values?.ReturnAirlineID
            ? +values?.ReturnAirlineID
            : null,
          ReturnAirlineNo: values?.ReturnAirlineNo
            ? values?.ReturnAirlineNo
            : "",
          ReturnFromAirportID: values?.ReturnFromAirportID
            ? +values?.ReturnFromAirportID
            : null,
          ReturnToAirportID: values?.ReturnToAirportID
            ? +values?.ReturnToAirportID
            : null,
          ReturnDepartureDate: values?.ReturnDepartureDate
            ? moment(values?.ReturnDepartureDate)?.format("YYYY-MM-DD")
            : null,
          ReturnDepartureTime: values?.ReturnDepartureTime
            ? moment(values?.ReturnDepartureTime)?.format("HH:mm:ss")
            : "",
          ReturnArrivalDate: values?.ReturnArrivalDate
            ? moment(values?.ReturnArrivalDate)?.format("YYYY-MM-DD")
            : null,
          ReturnArrivalTime: values?.ReturnArrivalTime
            ? moment(values?.ReturnArrivalTime)?.format("HH:mm:ss")
            : "",
          ReturnStops: values?.ReturnStops ? values?.ReturnStops : "",
          ReturnAdultsCost: values?.ReturnAdultsCost
            ? +values?.ReturnAdultsCost
            : null,
          ReturnAdultsMarkup: values?.ReturnAdultsMarkup
            ? +values?.ReturnAdultsMarkup
            : null,
          ReturnChildCost: values?.ReturnChildCost
            ? +values?.ReturnChildCost
            : null,
          ReturnChildMarkup: values?.ReturnChildMarkup
            ? +values?.ReturnChildMarkup
            : null,
          ReturnInfantCost: values?.ReturnInfantCost
            ? +values?.ReturnInfantCost
            : null,
          ReturnInfantMarkup: values?.ReturnInfantMarkup
            ? +values?.ReturnInfantMarkup
            : null,
          TotalReturnMarkup: values?.TotalReturnMarkup
            ? +values?.TotalReturnMarkup
            : null,
          TotalReturnCost: values?.TotalReturnCost
            ? +values?.TotalReturnCost
            : null,
          ReturnGrandTotal: values?.ReturnGrandTotal
            ? +values?.ReturnGrandTotal
            : null,
          TotalAdultTickets: values?.TotalAdultTickets
            ? +values?.TotalAdultTickets
            : null,
          TotalChildTickets: values?.TotalChildTickets
            ? +values?.TotalChildTickets
            : null,
          TotalInfantTickets: values?.TotalInfantTickets
            ? +values?.TotalInfantTickets
            : null,
          MainAdultsCost: values?.MainAdultsCost
            ? +values?.MainAdultsCost
            : null,
          MainAdultsMarkup: values?.MainAdultsMarkup
            ? +values?.MainAdultsMarkup
            : null,
          MainChildCost: values?.MainChildCost ? +values?.MainChildCost : null,
          MainChildMarkup: values?.MainChildMarkup
            ? +values?.MainChildMarkup
            : null,
          MainInfantCost: values?.MainInfantCost
            ? +values?.MainInfantCost
            : null,
          MainInfantMarkup: values?.MainInfantMarkup
            ? +values?.MainInfantMarkup
            : null,
          MainTotalTickets: values?.MainTotalTickets
            ? +values?.MainTotalTickets
            : null,
          MainTotalMarkup: values?.MainTotalMarkup
            ? +values?.MainTotalMarkup
            : null,
          MainTotalCost: values?.MainTotalCost ? +values?.MainTotalCost : null,
          MainGrandTotal: values?.MainGrandTotal
            ? +values?.MainGrandTotal
            : null,

          DepartureAdult: values?.DepartureAdult
            ? +values?.DepartureAdult
            : null,
          DepartureChild: values?.DepartureChild
            ? +values?.DepartureChild
            : null,
          DepartureInfant: values?.DepartureInfant
            ? +values?.DepartureInfant
            : null,
          TotalDeparturePax: values?.TotalDeparturePax
            ? +values?.TotalDeparturePax
            : null,
          ReturnAdult: values?.DepartureAdult ? +values?.DepartureAdult : null,
          ReturnChild: values?.DepartureChild ? +values?.DepartureChild : null,
          ReturnInfant: values?.DepartureInfant
            ? +values?.DepartureInfant
            : null,
          TotalReturnPax: values?.TotalDeparturePax
            ? +values?.TotalDeparturePax
            : null,
          // ReturnAdult: values?.ReturnAdult ? +values?.ReturnAdult : null,
          // ReturnChild: values?.ReturnChild ? +values?.ReturnChild : null,
          // ReturnInfant: values?.ReturnInfant ? +values?.ReturnInfant : null,
          // TotalReturnPax: values?.TotalReturnPax
          //   ? +values?.TotalReturnPax
          //   : null,
          BookingStatus: values?.BookingStatus ? values?.BookingStatus : "",
        };
        // if (editPayload) return;
        const response = await dispatch(updateFlightQuotation(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/quotation");
          dispatch(setQuotationType("flight"));
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          LeadID: values?.LeadID ? +values?.LeadID : null,
          InquiryID: values?.InquiryID ? +values?.InquiryID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          EmailID: values?.EmailID ? values?.EmailID : "",

          FlightScope: values?.FlightScope ? +values?.FlightScope : null,
          VendorID: values?.VendorID ? +values?.VendorID : null,
          CurrencyID: values?.CurrencyID ? +values?.CurrencyID : null,

          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          FlightClassID: values?.FlightClassID ? +values?.FlightClassID : null,
          GSTPer: values?.GSTPer ? +values?.GSTPer : null,
          GSTAmount: values?.GSTAmount ? +values?.GSTAmount : null,
          TCSPer: values?.TCSPer ? +values?.TCSPer : null,
          TCSAmount: values?.TCSAmount ? +values?.TCSAmount : null,
          ValidUntil: values?.ValidUntil
            ? moment(values?.ValidUntil)?.format("YYYY-MM-DD")
            : null,

          TripType: values?.TripType ? values?.TripType : "",
          TextBaseDescription: values?.TextBaseDescription || "",
          IsRefundable: values?.IsRefundable || false,
          IsFlightRateMayBeChanged: values?.IsFlightRateMayBeChanged || false,
          AirlineID: values?.AirlineID ? +values?.AirlineID : null,
          AirlineNo: values?.AirlineNo || "",
          FromAirportID: values?.FromAirportID ? +values?.FromAirportID : null,
          ToAirportID: values?.ToAirportID ? +values?.ToAirportID : null,
          DepartureDate: values?.DepartureDate
            ? moment(values?.DepartureDate)?.format("YYYY-MM-DD")
            : null,
          DepartureTime: values?.DepartureTime
            ? moment(values?.DepartureTime)?.format("HH:mm:ss")
            : "",
          ArrivalDate: values?.ArrivalDate
            ? moment(values?.ArrivalDate)?.format("YYYY-MM-DD")
            : null,
          ArrivalTime: values?.ArrivalTime
            ? moment(values?.ArrivalTime)?.format("HH:mm:ss")
            : "",
          Stops: values?.Stops || "",
          AdultsCost: values?.AdultsCost ? +values?.AdultsCost : null,
          AdultsMarkup: values?.AdultsMarkup ? +values?.AdultsMarkup : null,
          ChildCost: values?.ChildCost ? +values?.ChildCost : null,
          ChildMarkup: values?.ChildMarkup ? +values?.ChildMarkup : null,
          InfantCost: values?.InfantCost ? +values?.InfantCost : null,
          InfantMarkup: values?.InfantMarkup ? +values?.InfantMarkup : null,
          FareRules: values?.FareRules || "",
          IsSharePPPrice: values?.IsSharePPPrice || false,
          GrandTotal: values?.GrandTotal ? +values?.GrandTotal : null,
          TotalMarkup: values?.TotalMarkup ? +values?.TotalMarkup : null,
          TotalCost: values?.TotalCost ? +values?.TotalCost : null,
          ReturnCurrencyID: values?.ReturnCurrencyID
            ? +values?.ReturnCurrencyID
            : null,
          ReturnAirlineID: values?.ReturnAirlineID
            ? +values?.ReturnAirlineID
            : null,
          ReturnAirlineNo: values?.ReturnAirlineNo
            ? values?.ReturnAirlineNo
            : "",
          ReturnFromAirportID: values?.ReturnFromAirportID
            ? +values?.ReturnFromAirportID
            : null,
          ReturnToAirportID: values?.ReturnToAirportID
            ? +values?.ReturnToAirportID
            : null,
          ReturnDepartureDate: values?.ReturnDepartureDate
            ? moment(values?.ReturnDepartureDate)?.format("YYYY-MM-DD")
            : null,
          ReturnDepartureTime: values?.ReturnDepartureTime
            ? moment(values?.ReturnDepartureTime)?.format("HH:mm:ss")
            : "",
          ReturnArrivalDate: values?.ReturnArrivalDate
            ? moment(values?.ReturnArrivalDate)?.format("YYYY-MM-DD")
            : null,
          ReturnArrivalTime: values?.ReturnArrivalTime
            ? moment(values?.ReturnArrivalTime)?.format("HH:mm:ss")
            : "",
          ReturnStops: values?.ReturnStops ? values?.ReturnStops : "",
          ReturnAdultsCost: values?.ReturnAdultsCost
            ? +values?.ReturnAdultsCost
            : null,
          ReturnAdultsMarkup: values?.ReturnAdultsMarkup
            ? +values?.ReturnAdultsMarkup
            : null,
          ReturnChildCost: values?.ReturnChildCost
            ? +values?.ReturnChildCost
            : null,
          ReturnChildMarkup: values?.ReturnChildMarkup
            ? +values?.ReturnChildMarkup
            : null,
          ReturnInfantCost: values?.ReturnInfantCost
            ? +values?.ReturnInfantCost
            : null,
          ReturnInfantMarkup: values?.ReturnInfantMarkup
            ? +values?.ReturnInfantMarkup
            : null,
          TotalReturnMarkup: values?.TotalReturnMarkup
            ? +values?.TotalReturnMarkup
            : null,
          TotalReturnCost: values?.TotalReturnCost
            ? +values?.TotalReturnCost
            : null,
          ReturnGrandTotal: values?.ReturnGrandTotal
            ? +values?.ReturnGrandTotal
            : null,
          TotalAdultTickets: values?.TotalAdultTickets
            ? +values?.TotalAdultTickets
            : null,
          TotalChildTickets: values?.TotalChildTickets
            ? +values?.TotalChildTickets
            : null,
          TotalInfantTickets: values?.TotalInfantTickets
            ? +values?.TotalInfantTickets
            : null,
          MainAdultsCost: values?.MainAdultsCost
            ? +values?.MainAdultsCost
            : null,
          MainAdultsMarkup: values?.MainAdultsMarkup
            ? +values?.MainAdultsMarkup
            : null,
          MainChildCost: values?.MainChildCost ? +values?.MainChildCost : null,
          MainChildMarkup: values?.MainChildMarkup
            ? +values?.MainChildMarkup
            : null,
          MainInfantCost: values?.MainInfantCost
            ? +values?.MainInfantCost
            : null,
          MainInfantMarkup: values?.MainInfantMarkup
            ? +values?.MainInfantMarkup
            : null,
          MainTotalTickets: values?.MainTotalTickets
            ? +values?.MainTotalTickets
            : null,
          MainTotalMarkup: values?.MainTotalMarkup
            ? +values?.MainTotalMarkup
            : null,
          MainTotalCost: values?.MainTotalCost ? +values?.MainTotalCost : null,
          MainGrandTotal: values?.MainGrandTotal
            ? +values?.MainGrandTotal
            : null,

          DepartureAdult: values?.DepartureAdult
            ? +values?.DepartureAdult
            : null,
          DepartureChild: values?.DepartureChild
            ? +values?.DepartureChild
            : null,
          DepartureInfant: values?.DepartureInfant
            ? +values?.DepartureInfant
            : null,
          TotalDeparturePax: values?.TotalDeparturePax
            ? +values?.TotalDeparturePax
            : null,
          ReturnAdult: values?.DepartureAdult ? +values?.DepartureAdult : null,
          ReturnChild: values?.DepartureChild ? +values?.DepartureChild : null,
          ReturnInfant: values?.DepartureInfant
            ? +values?.DepartureInfant
            : null,
          TotalReturnPax: values?.TotalDeparturePax
            ? +values?.TotalDeparturePax
            : null,
          // ReturnAdult: values?.ReturnAdult ? +values?.ReturnAdult : null,
          // ReturnChild: values?.ReturnChild ? +values?.ReturnChild : null,
          // ReturnInfant: values?.ReturnInfant ? +values?.ReturnInfant : null,
          // TotalReturnPax: values?.TotalReturnPax
          //   ? +values?.TotalReturnPax
          //   : null,
          BookingStatus: values?.BookingStatus ? values?.BookingStatus : "",
        };
        const response = await dispatch(createFlightQuotation(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate("/quotation");
          dispatch(setQuotationType("flight"));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {(loading || contactLoading || leadLoading) && (
        <LoadingPanel gridRef={gridRef} />
      )}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head">
                    {"Flight Quotation Details"}
                  </Typography.h4>
                </GridLayoutItem>

                {FlightQuotationID || InquiryID || LeadID || ContactID ? (
                  <GridLayoutItem style={{ width: "100%" }} colSpan={3}>
                    <table className="w-100">
                      <tr>
                        <th>Name</th>
                        <td>:</td>
                        <td>
                          {initialValues?.Initial} {initialValues?.FirstName}{" "}
                          {initialValues?.LastName}
                        </td>
                      </tr>
                      <tr>
                        <th>Mobile No.</th>
                        <td>:</td>
                        <td>{initialValues?.MobileNo}</td>
                        <th>Email ID</th>
                        <td>:</td>
                        <td>{initialValues?.EmailID}</td>
                      </tr>
                    </table>
                    <hr className="mb-1" />
                  </GridLayoutItem>
                ) : (
                  <>
                    <GridLayoutItem className="d-flex gap-2">
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 1,
                        }}
                        id={"Initial"}
                        name={"Initial"}
                        label={"Initial"}
                        placeholder="i.e. Mr."
                        component={FormSelectionField}
                        options={NAMEPREFIX?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                      <Field
                        wrapperStyle={{
                          width: "100%",
                          flex: 2,
                        }}
                        name="FirstName"
                        label="First Name"
                        placeholder="i.e.John"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="LastName"
                        label="Last Name"
                        placeholder="i.e. Smith"
                        maxLength="100"
                        component={FormTextField}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="EmailID"
                        label="Email ID"
                        astrike={true}
                        placeholder="i.e. example@gmail.com"
                        component={FormTextField}
                        validator={emailValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem className="mb-1">
                      <Field
                        name="MobileNo"
                        label="Mobile No."
                        type="text"
                        maxLength={16}
                        onKeyPress={(e: any) => {
                          const allowedChars = /^[0-9+]$/;
                          if (!allowedChars.test(e?.key)) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="i.e. 9999999999"
                        component={FormTextField}
                        astrike={true}
                        validator={MobileNoIntValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        id={"LeadSourceID"}
                        name={"LeadSourceID"}
                        label={"Lead Source"}
                        placeholder="Lead Source"
                        component={FormSelectionField}
                        astrike={true}
                        validator={requiredValidator}
                        options={LeadSourceList?.map(
                          (leadsource: ILeadSource) => {
                            return {
                              value: leadsource?.ID,
                              label: leadsource?.Source,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3}>
                      <hr className="mb-1" />
                    </GridLayoutItem>
                  </>
                )}
                <GridLayoutItem colSpan={3}>
                  <div
                    style={{
                      background: "#edeaea",
                      borderRadius: 10,
                      padding: "1px 10px 15px",
                      fontWeight: 600,
                    }}
                  >
                    <Field
                      label={"Select Scope"}
                      id={"FlightScope"}
                      name={"FlightScope"}
                      component={FormRadioGroup}
                      layout="horizontal"
                      options={FLIGHTQUOTETYPE}
                      validator={requiredValidator}
                      wrapperClassName="d-flex align-items-center gap-4"
                    />
                  </div>
                </GridLayoutItem>
              </GridLayout>

              {formRenderProps.valueGetter("FlightScope") === 1 ? (
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem>
                    {/* <Field
                      name={`VendorID`}
                      label="Supplier Name (Vendor)"
                      placeholder="Supplier Name"
                      component={FormSelectionField}
                      options={VendorList?.map((vendor: IVendor) => {
                        return {
                          value: vendor?.ID,
                          label: vendor?.VendorName,
                        };
                      })}
                    /> */}
                    <Field
                      astrike={true}
                      validator={requiredValidator}
                      name={`VendorID`}
                      label="Supplier Name (Vendor)"
                      placeholder="Supplier Name"
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleVendorSearchChange(
                          search,
                          "vendor_option",
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("vendor_option")
                          ?.map((item: any) => {
                            return {
                              value: item?.ID,
                              label: item?.VendorName,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"CurrencyID"}
                      name={"CurrencyID"}
                      label={"Currency"}
                      placeholder="Currency"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={CurrencyList?.map((currency: ICurrency) => {
                        return {
                          value: currency.ID,
                          label: currency.CurrencyName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem className="trip-type-griditem">
                    <Field
                      id={"TripType"}
                      name={"TripType"}
                      label={"Trip Type"}
                      component={FormRadioGroup}
                      layout="horizontal"
                      options={TRIPTYPE}
                      validator={requiredValidator}
                      // astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"CompanyID"}
                      name={"CompanyID"}
                      label={"Company"}
                      placeholder="Company"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={CompanyList?.map((company: ICompany) => {
                        return {
                          value: company?.ID,
                          label: company?.CompanyName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="ValidUntil"
                      label="Valid Until Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                      minDate={moment().toDate()}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`BookingStatus`}
                      label="Booking Status"
                      placeholder="Booking Status"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={BOOKINGSTATUSHOTEL?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="TextBaseDescription"
                      label="Flight Details"
                      placeholder="Details"
                      component={FormRichTextField}
                      wrapperStyle={{
                        width: "100%",
                      }}
                      style={{
                        height: 350,
                      }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={3}
                    style={{
                      textAlign: "end",
                      marginTop: 20,
                      width: "100%",
                    }}
                  >
                    <ButtonWithLoading
                      label={FlightQuotationID ? "Update" : "Save"}
                      type="submit"
                      disabled={
                        !formRenderProps.allowSubmit ||
                        loading ||
                        contactLoading
                      }
                      loading={loading || contactLoading}
                    />
                    <RippleButton
                      fillMode="outline"
                      themeColor="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </RippleButton>
                  </GridLayoutItem>
                </GridLayout>
              ) : (
                <GridLayout
                  style={{ marginRight: 30 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                    { width: "25%" },
                  ]}
                >
                  <GridLayoutItem>
                    {/* <Field
                      name={`VendorID`}
                      label="Supplier Name (Vendor)"
                      placeholder="Supplier Name"
                      component={FormSelectionField}
                      options={VendorList?.map((vendor: IVendor) => {
                        return {
                          value: vendor?.ID,
                          label: vendor?.VendorName,
                        };
                      })}
                    /> */}
                    <Field
                      astrike={true}
                      validator={requiredValidator}
                      name={`VendorID`}
                      label="Supplier Name (Vendor)"
                      placeholder="Supplier Name"
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleVendorSearchChange(
                          search,
                          "vendor_option",
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("vendor_option")
                          ?.map((item: any) => {
                            return {
                              value: item?.ID,
                              label: item?.VendorName,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="IsRefundable"
                      label="Refundable"
                      wrapperStyle={{ marginTop: "40px" }}
                      labelClassName="fw-600"
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="IsFlightRateMayBeChanged"
                      label="Flight Rate may be changed"
                      wrapperStyle={{ marginTop: "40px" }}
                      labelClassName="fw-600"
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem className="trip-type-griditem">
                    <Field
                      id={"TripType"}
                      name={"TripType"}
                      label={"Trip Type"}
                      component={FormRadioGroup}
                      layout="horizontal"
                      options={TRIPTYPE}
                      validator={requiredValidator}
                      // astrike={true}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"CompanyID"}
                      name={"CompanyID"}
                      label={"Company"}
                      placeholder="Company"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={CompanyList?.map((company: ICompany) => {
                        return {
                          value: company?.ID,
                          label: company?.CompanyName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"FlightClassID"}
                      name={"FlightClassID"}
                      label={"Flight Class"}
                      placeholder="Flight Class"
                      component={FormSelectionField}
                      options={AirlineClassList?.map(
                        (airclass: IAirlineClass) => {
                          return {
                            value: airclass?.ID,
                            label: airclass?.ClassName,
                          };
                        }
                      )}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="ValidUntil"
                      label="Valid Until Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                      minDate={moment().toDate()}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`BookingStatus`}
                      label="Booking Status"
                      placeholder="Booking Status"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={BOOKINGSTATUSHOTEL?.map((status: any) => {
                        return {
                          value: status?.value,
                          label: status?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="IsTCSApplicable"
                      label="Is TCS Applicable"
                      component={FormCheckbox}
                      labelClassName="fw-600 m-0"
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={4}
                    style={{ margin: "20px 0px 0px 0px" }}
                  >
                    <Typography.h5 className="m-0">
                      {formRenderProps.valueGetter("TripType") === "Two Way"
                        ? "Inbound (Onwards Journey)"
                        : "Flight Details"}
                    </Typography.h5>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`AirlineID`}
                      label="Airline"
                      placeholder="Airline"
                      validator={requiredValidator}
                      component={FormSelectionField}
                      astrike={true}
                      options={AirlineList?.map((airline: IAirline) => {
                        return {
                          value: airline?.ID,
                          label: airline?.AirlineName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`AirlineNo`}
                      label="Airline No"
                      placeholder="6E"
                      component={FormTextField}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      astrike={true}
                      validator={requiredValidator}
                      name={`FromAirportID`}
                      label="From"
                      placeholder="From"
                      // component={FormSelectionField}
                      // options={FlightPlaceList?.map(
                      //   (flightplace: IFlightPlace) => {
                      //     return {
                      //       value: flightplace?.ID,
                      //       label: flightplace?.FlightPlaceName,
                      //     };
                      //   }
                      // )}
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleHotelSearchChange(
                          search,
                          "from_place_options",
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("from_place_options")
                          ?.map((item: any) => {
                            return {
                              value: item?.ID,
                              label: item?.FlightPlaceName,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      astrike={true}
                      validator={requiredValidator}
                      name={`ToAirportID`}
                      label="To"
                      placeholder="To"
                      // component={FormSelectionField}
                      // options={FlightPlaceList?.map(
                      //   (flightplace: IFlightPlace) => {
                      //     return {
                      //       value: flightplace?.ID,
                      //       label: flightplace?.FlightPlaceName,
                      //     };
                      //   }
                      // )}
                      component={FormIncrementalSearch}
                      fetchIncrementalData={(search: any) =>
                        handleHotelSearchChange(
                          search,
                          "to_place_options",
                          formRenderProps
                        )
                      }
                      options={
                        formRenderProps
                          .valueGetter("to_place_options")
                          ?.map((item: any) => {
                            return {
                              value: item?.ID,
                              label: item?.FlightPlaceName,
                            };
                          }) || []
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`DepartureDate`}
                      label="Departure Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                      minDate={moment().toDate()}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      validator={requiredValidator}
                      astrike={true}
                      name={`DepartureTime`}
                      label={"Departure Time"}
                      component={FormTimePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`ArrivalDate`}
                      label="Arrival Date"
                      format="dd/MM/yyyy"
                      component={FormDatePicker}
                      validator={requiredValidator}
                      astrike={true}
                      minDate={
                        formRenderProps.valueGetter("DepartureDate")
                          ? formRenderProps.valueGetter("DepartureDate")
                          : moment().toDate()
                      }
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      validator={requiredValidator}
                      astrike={true}
                      name={`ArrivalTime`}
                      label={"Arrival Time"}
                      component={FormTimePicker}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name={`Stops`}
                      label="Stops"
                      placeholder="Stops"
                      component={FormSelectionField}
                      validator={requiredValidator}
                      astrike={true}
                      options={AIRLINESTOPS?.map((stop: any) => {
                        return {
                          value: stop?.value,
                          label: stop?.label,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      id={"CurrencyID"}
                      name={"CurrencyID"}
                      label={"Currency"}
                      placeholder="Currency"
                      component={FormSelectionField}
                      astrike={true}
                      validator={requiredValidator}
                      options={CurrencyList?.map((currency: ICurrency) => {
                        return {
                          value: currency.ID,
                          label: currency.CurrencyName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem colSpan={4}>
                    <table
                      className="w-100 border-collapse border border-gray-300 mt-4"
                      style={{ background: "#f3f4f6" }}
                    >
                      <thead>
                        <tr>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Pax
                          </th>
                          <th
                            className="border border-gray-300 px-4 py-2 text-left"
                            style={{ width: 175 }}
                          >
                            No. Of Passenger
                          </th>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Cost (P.P)
                          </th>
                          <th className="border border-gray-300 px-4 py-2 text-left">
                            Markup (P.P)
                          </th>
                          <th
                            className="border border-gray-300 px-4 py-2 text-left"
                            style={{ minWidth: 150 }}
                          >
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2 fw-600">
                            Adults
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="DepartureAdult"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="AdultsCost"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                              errorMessageShown={false}
                              validator={requiredValidator}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="AdultsMarkup"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {((formRenderProps.valueGetter("AdultsCost") ||
                                0) +
                                (formRenderProps.valueGetter("AdultsMarkup") ||
                                  0)) *
                                (formRenderProps.valueGetter(
                                  "DepartureAdult"
                                ) || 0)}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2 fw-600">
                            Child (2-11 yrs)
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="DepartureChild"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="ChildCost"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="ChildMarkup"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {((formRenderProps.valueGetter("ChildCost") ||
                                0) +
                                (formRenderProps.valueGetter("ChildMarkup") ||
                                  0)) *
                                (formRenderProps.valueGetter(
                                  "DepartureChild"
                                ) || 0)}
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2 fw-600">
                            Infant (0-2 yrs)
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="DepartureInfant"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="InfantCost"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <Field
                              wrapperClassName="right-aligned-field mt-0"
                              name="InfantMarkup"
                              placeholder="0"
                              format="n0"
                              component={FormNumericTextField}
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {((formRenderProps.valueGetter("InfantCost") ||
                                0) +
                                (formRenderProps.valueGetter("InfantMarkup") ||
                                  0)) *
                                (formRenderProps.valueGetter(
                                  "DepartureInfant"
                                ) || 0)}
                            </strong>
                          </td>
                        </tr>
                        <tr className="bg-gray-100 font-semibold">
                          <td className="border border-gray-300 px-4 py-2 fw-bold">
                            Total
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {formRenderProps.valueGetter(
                                "TotalDeparturePax"
                              ) || 0}
                            </strong>
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {formRenderProps.valueGetter("TotalCost") || 0}
                            </strong>
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {formRenderProps.valueGetter("TotalMarkup") || 0}
                            </strong>
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-end">
                            <strong style={{ padding: "4px 8px" }}>
                              {formRenderProps.valueGetter("GrandTotal") || 0}
                            </strong>
                          </td>
                        </tr>
                        {formRenderProps.valueGetter("TripType") ===
                          "One Way" && (
                          <>
                            <tr className="bg-gray-100 font-semibold">
                              <td
                                className="border border-gray-300 px-4 py-2 text-end"
                                colSpan={3}
                              >
                                <strong style={{ padding: "4px 8px" }}>
                                  GST
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end ">
                                <div className="d-flex justify-content-between gap-1">
                                  <Field
                                    style
                                    wrapperClassName="right-aligned-field mt-0"
                                    name="GSTPer"
                                    placeholder="GST (%)"
                                    format="n0"
                                    min={0}
                                    max={100}
                                    component={FormNumericTextField}
                                    wrapperStyle={{ maxWidth: 80 }}
                                  />
                                  <strong style={{ padding: "4px 8px" }}>
                                    {formRenderProps.valueGetter("GSTAmount") ||
                                      0}
                                  </strong>
                                </div>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "SubTotalAfterGST"
                                  ) || 0}
                                </strong>
                              </td>
                            </tr>
                            {formRenderProps.valueGetter("IsTCSApplicable") && (
                              <tr className="bg-gray-100 font-semibold">
                                <td
                                  className="border border-gray-300 px-4 py-2 text-end"
                                  colSpan={3}
                                >
                                  <strong style={{ padding: "4px 8px" }}>
                                    TCS
                                  </strong>
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end ">
                                  <div className="d-flex justify-content-between gap-1">
                                    <Field
                                      style
                                      wrapperClassName="right-aligned-field mt-0"
                                      name="TCSPer"
                                      placeholder="GST (%)"
                                      format="n0"
                                      min={0}
                                      max={100}
                                      disabled={true}
                                      component={FormNumericTextField}
                                      wrapperStyle={{ maxWidth: 80 }}
                                    />
                                    <strong style={{ padding: "4px 8px" }}>
                                      {formRenderProps.valueGetter(
                                        "TCSAmount"
                                      ) || 0}
                                    </strong>
                                  </div>
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end">
                                  <strong style={{ padding: "4px 8px" }}>
                                    {formRenderProps.valueGetter(
                                      "SubTotalAfterTCS"
                                    ) || 0}
                                  </strong>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                  </GridLayoutItem>
                  {formRenderProps.valueGetter("TripType") === "Two Way" && (
                    <>
                      <GridLayoutItem
                        colSpan={4}
                        style={{ margin: "20px 0px 0px 0px" }}
                      >
                        <Typography.h5 className="m-0">
                          Outbound (Return Journey)
                        </Typography.h5>
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name={`ReturnAirlineID`}
                          label="Airline"
                          placeholder="Airline"
                          validator={requiredValidator}
                          component={FormSelectionField}
                          astrike={true}
                          options={AirlineList?.map((airline: IAirline) => {
                            return {
                              value: airline?.ID,
                              label: airline?.AirlineName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name={`ReturnAirlineNo`}
                          label="Airline No"
                          placeholder="6E"
                          component={FormTextField}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          astrike={true}
                          validator={requiredValidator}
                          name={`ReturnFromAirportID`}
                          label="From"
                          placeholder="From"
                          component={FormIncrementalSearch}
                          fetchIncrementalData={(search: any) =>
                            handleHotelSearchChange(
                              search,
                              "return_from_place_options",
                              formRenderProps
                            )
                          }
                          options={
                            formRenderProps
                              .valueGetter("return_from_place_options")
                              ?.map((item: any) => {
                                return {
                                  value: item?.ID,
                                  label: item?.FlightPlaceName,
                                };
                              }) || []
                          }
                          // options={FlightPlaceList?.map(
                          //   (flightplace: IFlightPlace) => {
                          //     return {
                          //       value: flightplace?.ID,
                          //       label: flightplace?.FlightPlaceName,
                          //     };
                          //   }
                          // )}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          astrike={true}
                          validator={requiredValidator}
                          name={`ReturnToAirportID`}
                          label="To"
                          placeholder="To"
                          component={FormIncrementalSearch}
                          fetchIncrementalData={(search: any) =>
                            handleHotelSearchChange(
                              search,
                              "return_to_place_options",
                              formRenderProps
                            )
                          }
                          options={
                            formRenderProps
                              .valueGetter("return_to_place_options")
                              ?.map((item: any) => {
                                return {
                                  value: item?.ID,
                                  label: item?.FlightPlaceName,
                                };
                              }) || []
                          }
                          // component={FormSelectionField}
                          // options={FlightPlaceList?.map(
                          //   (flightplace: IFlightPlace) => {
                          //     return {
                          //       value: flightplace?.ID,
                          //       label: flightplace?.FlightPlaceName,
                          //     };
                          //   }
                          // )}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          validator={requiredValidator}
                          astrike={true}
                          name={`ReturnDepartureDate`}
                          label="Departure Date"
                          format="dd/MM/yyyy"
                          component={FormDatePicker}
                          minDate={moment().toDate()}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          validator={requiredValidator}
                          astrike={true}
                          name={`ReturnDepartureTime`}
                          label={"Departure Time"}
                          component={FormTimePicker}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          validator={requiredValidator}
                          astrike={true}
                          name={`ReturnArrivalDate`}
                          label="Arrival Date"
                          format="dd/MM/yyyy"
                          component={FormDatePicker}
                          minDate={
                            formRenderProps.valueGetter("ReturnDepartureDate")
                              ? formRenderProps.valueGetter(
                                  "ReturnDepartureDate"
                                )
                              : moment().toDate()
                          }
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          validator={requiredValidator}
                          astrike={true}
                          name={`ReturnArrivalTime`}
                          label={"Arrival Time"}
                          component={FormTimePicker}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          name={`ReturnStops`}
                          label="Stops"
                          placeholder="Stops"
                          component={FormSelectionField}
                          validator={requiredValidator}
                          astrike={true}
                          options={AIRLINESTOPS?.map((stop: any) => {
                            return {
                              value: stop?.value,
                              label: stop?.label,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem>
                        <Field
                          id={"ReturnCurrencyID"}
                          name={"ReturnCurrencyID"}
                          label={"Currency"}
                          placeholder="Currency"
                          component={FormSelectionField}
                          astrike={true}
                          validator={requiredValidator}
                          options={CurrencyList?.map((currency: ICurrency) => {
                            return {
                              value: currency.ID,
                              label: currency.CurrencyName,
                            };
                          })}
                        />
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={2}></GridLayoutItem>
                      <GridLayoutItem colSpan={4}>
                        <table
                          className="w-100 border-collapse border border-gray-300 mt-4"
                          style={{ background: "#f3f4f6" }}
                        >
                          <thead>
                            <tr>
                              <th className="border border-gray-300 px-4 py-2 text-left">
                                Pax
                              </th>
                              <th
                                className="border border-gray-300 px-4 py-2 text-left"
                                style={{ width: 175 }}
                              >
                                No. Of Passenger
                              </th>
                              <th className="border border-gray-300 px-4 py-2 text-left">
                                Cost (P.P)
                              </th>
                              <th className="border border-gray-300 px-4 py-2 text-left">
                                Markup (P.P)
                              </th>
                              <th
                                className="border border-gray-300 px-4 py-2 text-left"
                                style={{ minWidth: 150 }}
                              >
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 fw-600">
                                Adults
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="DepartureAdult"
                                  // name="ReturnAdult"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="ReturnAdultsCost"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                  errorMessageShown={false}
                                  validator={requiredValidator}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="ReturnAdultsMarkup"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {((formRenderProps.valueGetter(
                                    "ReturnAdultsCost"
                                  ) || 0) +
                                    (formRenderProps.valueGetter(
                                      "ReturnAdultsMarkup"
                                    ) || 0)) *
                                    (formRenderProps.valueGetter(
                                      "DepartureAdult"
                                    ) || 0)}
                                  {/* (formRenderProps.valueGetter(
                                      "ReturnAdult"
                                    ) || 0)} */}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 fw-600">
                                Child (2-11 yrs)
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  // name="ReturnChild"
                                  name="DepartureChild"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="ReturnChildCost"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="ReturnChildMarkup"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {((formRenderProps.valueGetter(
                                    "ReturnChildCost"
                                  ) || 0) +
                                    (formRenderProps.valueGetter(
                                      "ReturnChildMarkup"
                                    ) || 0)) *
                                    (formRenderProps.valueGetter(
                                      "DepartureChild"
                                    ) || 0)}
                                  {/* (formRenderProps.valueGetter(
                                      "ReturnChild"
                                    ) || 0)} */}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 fw-600">
                                Infant (0-2 yrs)
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  // name="ReturnInfant"
                                  name="DepartureInfant"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="ReturnInfantCost"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2">
                                <Field
                                  wrapperClassName="right-aligned-field mt-0"
                                  name="ReturnInfantMarkup"
                                  placeholder="0"
                                  format="n0"
                                  component={FormNumericTextField}
                                />
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {((formRenderProps.valueGetter(
                                    "ReturnInfantCost"
                                  ) || 0) +
                                    (formRenderProps.valueGetter(
                                      "ReturnInfantMarkup"
                                    ) || 0)) *
                                    (formRenderProps.valueGetter(
                                      "DepartureInfant"
                                    ) || 0)}
                                  {/* (formRenderProps.valueGetter(
                                      "ReturnInfant"
                                    ) || 0)} */}
                                </strong>
                              </td>
                            </tr>
                            <tr className="bg-gray-100 font-semibold">
                              <td className="border border-gray-300 px-4 py-2 fw-bold">
                                Total
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "TotalDeparturePax"
                                    // "TotalReturnPax"
                                  ) || 0}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "TotalReturnCost"
                                  ) || 0}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "TotalReturnMarkup"
                                  ) || 0}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "ReturnGrandTotal"
                                  ) || 0}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </GridLayoutItem>
                      <GridLayoutItem
                        colSpan={4}
                        style={{ margin: "20px 0px 0px 0px" }}
                      >
                        <Typography.h5 className="m-0">
                          Total Cost Summary
                        </Typography.h5>
                      </GridLayoutItem>
                      <GridLayoutItem colSpan={4}>
                        <table
                          className="w-100 border-collapse border border-gray-300 mt-2"
                          style={{ background: "#f3f4f6" }}
                        >
                          <thead>
                            <tr>
                              <th className="border border-gray-300 px-4 py-2 text-left">
                                Pax
                              </th>
                              <th
                                className="border border-gray-300 px-4 py-2 text-left"
                                style={{ width: 175 }}
                              >
                                No. Of Passenger
                              </th>
                              <th className="border border-gray-300 px-4 py-2 text-left">
                                Total Cost
                              </th>
                              <th className="border border-gray-300 px-4 py-2 text-left">
                                Total Markup
                              </th>
                              <th
                                className="border border-gray-300 px-4 py-2 text-left"
                                style={{ minWidth: 150 }}
                              >
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 fw-600">
                                Adults
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {
                                    +(
                                      formRenderProps.valueGetter(
                                        "DepartureAdult"
                                      ) || 0
                                    )
                                    //  +
                                    //   +(
                                    //     formRenderProps.valueGetter(
                                    //       "ReturnAdult"
                                    //     ) || 0
                                    //   )
                                  }
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainAdultsCost"
                                  )}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainAdultsMarkup"
                                  )}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {((formRenderProps.valueGetter(
                                    "MainAdultsCost"
                                  ) || 0) +
                                    (formRenderProps.valueGetter(
                                      "MainAdultsMarkup"
                                    ) || 0)) *
                                    formRenderProps.valueGetter(
                                      "DepartureAdult"
                                    )}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 fw-600">
                                Child (2-11 yrs)
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {
                                    +(
                                      formRenderProps.valueGetter(
                                        "DepartureChild"
                                      ) || 0
                                    )
                                    // +
                                    //   +(
                                    //     formRenderProps.valueGetter(
                                    //       "ReturnChild"
                                    //     ) || 0
                                    //   )
                                  }
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter("MainChildCost")}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainChildMarkup"
                                  )}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {((formRenderProps.valueGetter(
                                    "MainChildCost"
                                  ) || 0) +
                                    (formRenderProps.valueGetter(
                                      "MainChildMarkup"
                                    ) || 0)) *
                                    formRenderProps.valueGetter(
                                      "DepartureChild"
                                    )}
                                </strong>
                              </td>
                            </tr>
                            <tr>
                              <td className="border border-gray-300 px-4 py-2 fw-600">
                                Infant (0-2 yrs)
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {
                                    +(
                                      formRenderProps.valueGetter(
                                        "DepartureInfant"
                                      ) || 0
                                    )
                                    // +
                                    //   +(
                                    //     formRenderProps.valueGetter(
                                    //       "ReturnInfant"
                                    //     ) || 0
                                    //   )
                                  }
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainInfantCost"
                                  )}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainInfantMarkup"
                                  )}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {((formRenderProps.valueGetter(
                                    "MainInfantCost"
                                  ) || 0) +
                                    (formRenderProps.valueGetter(
                                      "MainInfantMarkup"
                                    ) || 0)) *
                                    formRenderProps.valueGetter(
                                      "DepartureInfant"
                                    )}
                                </strong>
                              </td>
                            </tr>
                            <tr className="bg-gray-100 font-semibold">
                              <td className="border border-gray-300 px-4 py-2 fw-bold">
                                Total
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {
                                    +(
                                      formRenderProps.valueGetter(
                                        "TotalDeparturePax"
                                      ) || 0
                                    )
                                    // +
                                    //   +(
                                    //     formRenderProps.valueGetter(
                                    //       "TotalReturnPax"
                                    //     ) || 0
                                    //   )
                                  }
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainTotalCost"
                                  ) || 0}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainTotalMarkup"
                                  ) || 0}
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "MainGrandTotal"
                                  ) || 0}
                                </strong>
                              </td>
                            </tr>
                            <tr className="bg-gray-100 font-semibold">
                              <td
                                className="border border-gray-300 px-4 py-2 text-end"
                                colSpan={3}
                              >
                                <strong style={{ padding: "4px 8px" }}>
                                  GST
                                </strong>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end ">
                                <div className="d-flex justify-content-between gap-1">
                                  <Field
                                    style
                                    wrapperClassName="right-aligned-field mt-0"
                                    name="GSTPer"
                                    placeholder="GST (%)"
                                    format="n0"
                                    min={0}
                                    max={100}
                                    component={FormNumericTextField}
                                    wrapperStyle={{ maxWidth: 80 }}
                                  />
                                  <strong style={{ padding: "4px 8px" }}>
                                    {formRenderProps.valueGetter("GSTAmount") ||
                                      0}
                                  </strong>
                                </div>
                              </td>
                              <td className="border border-gray-300 px-4 py-2 text-end">
                                <strong style={{ padding: "4px 8px" }}>
                                  {formRenderProps.valueGetter(
                                    "SubTotalAfterGST"
                                  ) || 0}
                                </strong>
                              </td>
                            </tr>
                            {formRenderProps.valueGetter("IsTCSApplicable") && (
                              <tr className="bg-gray-100 font-semibold">
                                <td
                                  className="border border-gray-300 px-4 py-2 text-end"
                                  colSpan={3}
                                >
                                  <strong style={{ padding: "4px 8px" }}>
                                    TCS
                                  </strong>
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end ">
                                  <div className="d-flex justify-content-between gap-1">
                                    <Field
                                      style
                                      wrapperClassName="right-aligned-field mt-0"
                                      name="TCSPer"
                                      placeholder="GST (%)"
                                      format="n0"
                                      min={0}
                                      max={100}
                                      disabled={true}
                                      component={FormNumericTextField}
                                      wrapperStyle={{ maxWidth: 80 }}
                                    />
                                    <strong style={{ padding: "4px 8px" }}>
                                      {formRenderProps.valueGetter(
                                        "TCSAmount"
                                      ) || 0}
                                    </strong>
                                  </div>
                                </td>
                                <td className="border border-gray-300 px-4 py-2 text-end">
                                  <strong style={{ padding: "4px 8px" }}>
                                    {formRenderProps.valueGetter(
                                      "SubTotalAfterTCS"
                                    ) || 0}
                                  </strong>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </GridLayoutItem>
                    </>
                  )}
                  <GridLayoutItem colSpan={3}>
                    <Field
                      name="FareRules"
                      label="Fare Rules"
                      placeholder="Fare Rules"
                      component={FormRichTextField}
                      wrapperStyle={{
                        width: "100%",
                      }}
                      style={{
                        height: 150,
                      }}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem>
                    <Field
                      name="IsSharePPPrice"
                      label="Share PP Price"
                      wrapperStyle={{ marginTop: "40px" }}
                      labelClassName="fw-600"
                      component={FormCheckbox}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem
                    colSpan={4}
                    style={{
                      textAlign: "end",
                      marginTop: 20,
                      width: "100%",
                    }}
                  >
                    <ButtonWithLoading
                      label={FlightQuotationID ? "Update" : "Save"}
                      type="submit"
                      disabled={
                        !formRenderProps.allowSubmit ||
                        loading ||
                        contactLoading
                      }
                      loading={loading || contactLoading}
                    />
                    <RippleButton
                      fillMode="outline"
                      themeColor="primary"
                      style={{ marginLeft: 10 }}
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </RippleButton>
                  </GridLayoutItem>
                </GridLayout>
              )}
            </ShadowCard>
            <TotalChangeWatcher formRenderProps={formRenderProps} />
            <GSTChangeWatcher formRenderProps={formRenderProps} />
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateFlightQuotation;
